import { useState, useEffect, useContext } from 'react';


// 参加済み
function LiveReserveSituationLineBatchAttend(props: any) {
  const info = props.info;

  return (
    <>
    {info.is_attended === 1?
      <span className="label label-info" style={{ marginLeft: '10px' }}>予約中</span>
    :
      <>
        {info.is_attended === 2 &&
          <span className="label label-warning" style={{ marginLeft: '10px' }}>受講済</span>
        }
      </>
    }
    </>
  );
}
  
export default LiveReserveSituationLineBatchAttend;